import { withType } from '../../../../utils/actionOperations';
import {
  UPDATE_DIRECT_REPORTEE_HEATMAP_SCORE_LEVEL,
  UPDATE_DIRECT_REPORTEE_HEATMAP_COMPARISON_LEVEL
} from '../../../constants';

export * from './directReporteesHeatmapQuestions';
export * from './directReporteesHeatmapTable';
export * from './directReporteeResetFetchKey'

export const updateDirectReporteeScoreLevel = (params) => {
  return withType(UPDATE_DIRECT_REPORTEE_HEATMAP_SCORE_LEVEL, {
    data: params.scoreLevel,
  });
};

export const updateDirectReporteeComparisonLevel = (params) => {
  return withType(UPDATE_DIRECT_REPORTEE_HEATMAP_COMPARISON_LEVEL, {
    data: params.comparisonLevel,
  });
};
